import { render, staticRenderFns } from "./ParcoursMap.vue?vue&type=template&id=b4c70a62&"
import script from "./ParcoursMap.vue?vue&type=script&lang=js&"
export * from "./ParcoursMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports